// extracted by mini-css-extract-plugin
export var menuIcon = "_iw-0";
export var menuIconInline = "_iw-1";